const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the email body editor component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('emailBodyEditor', ['Application', 'FroalaOptions', function (Application, FroalaOptions) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        content: '=',
        toolbarAdditions: '=?',
        onBlur: '&?',
        onBlurValue: '@?',
        focusValue: '@?',
        focusVariable: '=?',
        title: '=?',
        editorConfigCallback: '=?',
        zoomAiEnabled: '<?',
        getZoomSummary: '=?',
      },
      template: require('../../../templates/directives/cms/email-body-editor.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.showingDetails = true;
        self.fillColor = Application.COLORS[0];

        if ($scope.title){
          self.title = $scope.title;
        };

        var usableEditor;

        self.manualFroalaInitializer = function(i){
          i.initialize();
          usableEditor = i.getEditor();
        };

        self.initHeights = function() {
            var collapsables = document.querySelectorAll('.js-collapsable .sixteen.wide.field');
            for ( var i = 0; i < collapsables.length; i++ ) {
              var origItem = collapsables[i];
              origItem.style.transition = '0.3s ease all';
              origItem.style.overflow = 'hidden';
              var compStyle = getComputedStyle(origItem);
              var trueHeight = parseInt(compStyle.height.replace('px', '')) - parseInt(compStyle.marginBottom.replace('px', ''));
              origItem.style.height = (trueHeight + 1) + 'px';
              origItem.dataset.height = (trueHeight + 1) + 'px';
              origItem.dataset.marginbottom = getComputedStyle(origItem).marginBottom;
              origItem.dataset.status = 'active';
            }
        };
        self.initHeights();

        self.toggleDetails = function(){
          var collapsables = document.querySelectorAll('.js-collapsable .sixteen.wide.field');
          for ( var i = 0; i < collapsables.length; i++ ) {
            var origItem = collapsables[i];
            if (origItem.dataset.status === 'active'){
              origItem.style.height = '0px';
              origItem.style.margin = '0px';
              origItem.setAttribute('class', 'sixteen wide field field--nomb');
              origItem.dataset.status = 'inactive';
              self.showingDetails = false;
              setTimeout(function(){
                self.setEditorHeightExtended()
              }, 100);
            } else {
              origItem.style.height = origItem.dataset.height;
              origItem.style.marginBottom = origItem.dataset.marginbottom;
              origItem.setAttribute('class', 'sixteen wide field');
              origItem.dataset.status = 'active';
              self.showingDetails = true;
              setTimeout(function(){
                self.setEditorHeightDefault();
              }, 100);
            }
          }
        };

        self.froalaLocalOptions = {
          height: 200,
          heightMax: 200,
          imageAddNewLine: true,
          imageInsertButtons: ['imageBack', '|', 'imageByURL'],
          imageUpload: false,
          imagePaste: false,
          fontSizeDefaultSelection: '10',
          inlineMode: true,
          fontSizeUnit: 'pt',
          fontSize: ['8', '9', '10','10.5', '11', '12', '14', '18', '20','24', '30','36'],
          events: {
            blur: function() {
              if ($scope.onBlur) {
                if ($scope.onBlurValue) {
                  $scope.onBlur({type: $scope.onBlurValue});
                  return;
                }
                $scope.onBlur();
              }
            },
            focus: function() {
              if ($scope.focusValue) {
                $scope.focusVariable = $scope.focusValue;
              }
              $scope.$apply();
            }
          },
          toolbarButtons: ['bold', 'italic', 'underline', 'fontSize', 'color', 'align', 'formatOL', 'formatUL', 'insertLink', 'insertImage', 'undo', 'redo', 'customClear'],
          linkInsertButtons: ['linkBack'],
          pasteAllowedStyleProps: Application.froalaConfig.pasteAllowedStyleProps,
          pasteDeniedAttrs: Application.froalaConfig.pasteDeniedAttrs,
          paragraphStyles: 	{
            'fr-text-title': 'Title',
            'fr-text-gray': 'Gray',
            'fr-text-branded': 'Branded',
            'fr-text-bordered': 'Bordered',
            'fr-text-spaced': 'Spaced',
            'fr-text-uppercase': 'Uppercase'
          },
          quickInsertButtons: ['image','link', 'ul', 'ol', 'hr'],
          charCounterCount: false,
          editorConfigCallbacks: [$scope.editorConfigCallback],
        };

        if ($scope.toolbarAdditions && $scope.toolbarAdditions.length) {
          self.froalaLocalOptions.toolbarButtons = self.froalaLocalOptions.toolbarButtons.concat( $scope.toolbarAdditions);
        }
        self.froalaOptions = Object.assign({}, self.froalaLocalOptions, FroalaOptions);

        self.changeElmHeights = function(elms, val) {
          if(elms.length){
            for (var i = 0; i < elms.length; i++) {
              elms[i].style.height = val;
              elms[i].style.minHeight = val;
              elms[i].style.maxHeight = val;
            }
          }
          if (usableEditor) {
            usableEditor.opts.height = val.replace('px','');
            usableEditor.size.refresh();
          }
        };

        self.setEditorHeightDefault = function(){
          setTimeout(function () {
            if (document.querySelector('.mesEditor__inner__content__main')) {
              self.editorHeight = document.querySelector('.mesEditor__inner__content__main').offsetHeight;
              self.frwrapper = document.querySelector('.fr-wrapper');
            }
          }, 100);

        };
        self.setEditorHeightDefault();

        self.setEditorHeightExtended = function(){
          self.editorHeight = document.querySelector('.mesEditor__inner__content__main').offsetHeight;
          self.frwrapper = document.querySelector('.fr-wrapper');
          var editorLabelHeight = document.querySelector('.mesEditor__inner__content__main .ui.form .edit__section:nth-child(3) .field label:first-child').offsetHeight ;
          var editorToolbarHeight = document.querySelector('.mesEditor__inner__content__main .fr-toolbar.fr-top').offsetHeight;
        };

        var resizeListener = function(){
          window.requestAnimationFrame(self.setEditorHeightDefault);
        }
        window.addEventListener('resize',resizeListener);

      }],
      controllerAs: 'emailEditor'
    };
  }]);
